import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { renderInput } from '../../utils';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Typography } from '@material-ui/core';

const List = withStyles(styles)(
  ({
    classes,
    i,
    treeTrace,
    errors,
    onChange,
    value = [],
    mode,
    renderChild,
    children,
    label,
    field = '',
    removeListItem,
    addListItem,
  }) => {
    // const { field, label, direction, disabledOnEdit, validate, listType, children } = i;
    const { expansionTitleFormat, maxListItems = null } = i;

    // go through each child object and check for any non null values
    const hasError = errors.map(e => Object.values(e).reduce((acc, cur) => (acc ? acc : cur), null)).filter(e => e)
      .length;

    // create a list of indexes that have errors (in order to make their title red)
    const errorIndexes = errors
      .map((e, index) =>
        [undefined, null].includes(Object.values(e).reduce((acc, cur) => (acc ? acc : cur), undefined)) ? null : index,
      )
      .filter(e => e !== null);

    const canAddAnotherItem = !maxListItems || !children || children.length < maxListItems;

    return (
      <div className={classes.inputContainer}>
        <p
          style={{
            marginBottom: 5,
            fontWeight: 400,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
          className={cn(classes.inputLabel, hasError && classes.textLabelError)}
          title={canAddAnotherItem ? 'Add a new entry' : 'Max entries reached'}
        >
          <AddCircleIcon
            fontSize={'small'}
            className={cn('list-action-icon', 'mr-10')}
            style={{
              color: canAddAnotherItem ? 'green' : 'gray',
              cursor: 'pointer',
            }}
            onClick={canAddAnotherItem ? addListItem : null}
          />
          {label}:{/* {!!error && error} */}
        </p>
        {children.map((child, childIndex, original) => (
          <div style={{ width: '100%' }}>
            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className={cn('row-start-center flex-1 text-left')}>
                  <DeleteIcon
                    fontSize={'small'}
                    className={cn('list-action-icon')}
                    style={{
                      color: 'red',
                      marginLeft: -10,
                      marginRight: 10,
                    }}
                    onClick={evt => {
                      evt.stopPropagation();
                      removeListItem(childIndex);
                    }}
                  />
                  <Typography
                    className={cn(classes.heading, 'flex-1')}
                    style={Object.assign(
                      {},
                      errorIndexes.includes(childIndex) && {
                        color: 'red',
                      },
                    )}
                  >
                    {expansionTitleFormat && expansionTitleFormat(value[childIndex], childIndex)}
                    {!expansionTitleFormat && `Item: ${childIndex + 1}`}
                  </Typography>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>{child}</ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        ))}
        {!children.length && (
          <div className={cn(classes.disabledText)} style={{ marginLeft: 15 }}>
            No list items... Please add one
          </div>
        )}
        {/* {children.map((child, childIndex, original) => (
          <div
            className={cn('full-width', 'column-start-start')}
            style={{
              paddingBottom: childIndex === original.length - 1 ? 0 : 10,
              paddingTop: !childIndex ? 0 : 10,
              borderBottom: childIndex === original.length - 1 ? null : '2px solid #aaa',
            }}
          >
            <DeleteIcon
              fontSize={'small'}
              className={cn('list-action-icon')}
              style={{
                color: 'red',
              }}
              onClick={handleRemoveListItem(childIndex)}
            />
            {child}
          </div>
        ))} */}
        {/* {value.map((val, valIndex) => {
        return (
          <div style={{ width: '100%' }}>
            {children.map((groupElement, groupElIndex) => {
              // console.log(groupElement);
              return (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-end',
                  }}
                >
                  <DeleteIcon
                    fontSize={'small'}
                    style={{
                      color: 'red',
                      marginRight: 10,
                      marginBottom: 20,
                    }}
                    onClick={handleRemoveListItem(valIndex)}
                  />
                  {renderChild(
                    {
                      // ...groupElement,
                      i: {
                        ...groupElement,
                        // inputType: listType,
                        isListItem: true,
                      },
                      errors,
                      data: val,
                      // data: {
                      //   [field]: val,
                      // },
                      onChange: (field, val, trace) => handleListChange(field, val, trace, valIndex),
                    },
                    groupElIndex,
                  )}
                </div>
              );
            })}
          </div>
        );
      })} */}
      </div>
    );
  },
);

export default List;
